export const dateTimeFormatter = (date: string) => {
	const _date = new Date(date);
	const formattedDate = _date.toLocaleDateString('pt-BR');
	const formattedTime = _date.toLocaleTimeString('pt-BR');

	return `${formattedDate} às ${formattedTime}`;
};
